import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import Cookies from 'js-cookie';
import { useNavigate } from '@remix-run/react';

export const useLogout = () => {
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: () => API.logout(),
    onSuccess: () => {
      Cookies.remove('token');
      navigate('/registration');
    },
  });

  return {
    logout: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
